<template>
  <button class="btn" @click="toToggle()">
    <BriefcaseIcon /> Портфель
  </button>
</template>

<script setup>
  import { useUserAuth } from '@/Groups/Briefcase/private/imports/userStoreData';
  import { useBriefcaseDropdown } from '@/Groups/Briefcase/private/imports/toggleDropdown';
  //-----------------------------------
  import BriefcaseIcon from '@/Groups/Briefcase/private/svg/BriefcaseIcon.vue';
  //-----------------------------------
  const { hasPaidAccount, isLoadingUserData } = useUserAuth();
  //-----------------------------------
  const { isOpen, close, open } = useBriefcaseDropdown();
  //-----------------------------------
  const toToggle = () => {
    if(!hasPaidAccount.value) return;
    isOpen.value ? close() : open();
  }
</script>

<style lang="scss" scoped>
  @import "./styles.scss";
</style>